import { graphql, operation, asNode } from "../lib/graphql";
import { Publissue } from ".";
import { buildQuery, QueryParams } from "../lib/query";
import { Post } from "../types/Post";

const FindPostQuery = operation(
  graphql(`
    query FindPost($query: String!, $omitBody: Boolean = false) {
      search(first: 1, type: ISSUE, query: $query) {
        nodes {
          ... on Issue {
            ...Post_Issue
          }
        }
      }
    }
  `),
).withMap((data) => {
  return data.search.nodes?.[0] ? Post.unmask(asNode(data.search.nodes[0], "Issue")) : null;
});

export async function findPost(
  this: Publissue,
  props?: {
    query?: QueryParams;
    omitBody?: boolean;
  },
) {
  return this.graphql(FindPostQuery).execute({
    query: buildQuery.call(this, props?.query),
    omitBody: props?.omitBody,
  });
}
